import type { SecaoDocumento } from '@/shared/components/documentos/paginado';

export const NUMERO_SECAO_LINHA_TEMPO = 4;

export const SECOES_SENTENCA_ARBITRAL: readonly SecaoDocumento[] = [
  {
    numero: 1,
    titulo: 'Informações da sentença',
    descricao: 'Dados de identificação do procedimento arbitral',
  },
  {
    numero: 2,
    titulo: 'Partes envolvidas',
    descricao: 'Requerente, requeridos e advogados do processo',
  },
  {
    numero: 3,
    titulo: 'A decisão do árbitro',
    descricao: 'O que a decisão significa e o texto oficial da sentença',
  },
  {
    numero: 4,
    titulo: 'Como o processo caminhou',
    descricao: 'Linha do tempo, do pedido inicial à sentença',
  },
  {
    numero: 5,
    titulo: 'O que significam os termos usados',
    descricao: 'Glossário dos termos jurídicos usados aqui',
  },
];

export function secoesVisiveisSentenca(temLinhaTempo: boolean): readonly SecaoDocumento[] {
  if (temLinhaTempo) return SECOES_SENTENCA_ARBITRAL;
  return SECOES_SENTENCA_ARBITRAL.filter((secao) => secao.numero !== NUMERO_SECAO_LINHA_TEMPO).map(
    (secao, indice) => ({ ...secao, numero: indice + 1 }),
  );
}

export function sumarioDescricaoSentenca(temLinhaTempo: boolean): string {
  if (temLinhaTempo) return TEXTOS_SENTENCA_ARBITRAL.sumarioDescricao;
  return 'O documento está organizado em 4 seções, na ordem abaixo. O início de cada uma é marcado por uma divisória numerada. As duas primeiras apresentam o caso e as pessoas envolvidas; a terceira traz o texto oficial da sentença, com valor legal; a última traz o glossário.';
}

export const TITULO_SENTENCA_ARBITRAL = 'Sentença Arbitral';

export const TEXTOS_SENTENCA_ARBITRAL = {
  eyebrowCapa: 'Processo Arbitral',
  sumarioTitulo: 'O que este documento contém',
  sumarioDescricao:
    'O documento está organizado em 5 seções, na ordem abaixo. O início de cada uma é marcado por uma divisória numerada. As duas primeiras apresentam o caso e as pessoas envolvidas; a terceira traz o texto oficial da sentença, com valor legal; as duas últimas trazem a linha do tempo do processo e o glossário.',
  identificacaoIntro: 'Dados de identificação do procedimento arbitral que originou esta sentença.',
  identificacaoColunaProcedimento: 'Identificação do procedimento',
  identificacaoColunaReferencias: 'Referências',
  partesIntro: 'Identificação de cada pessoa envolvida, com seu papel no processo.',
  decisaoIntro:
    'Primeiro, em três blocos, o que a decisão significa na prática. Em seguida, o texto oficial da sentença em linguagem jurídica, com o valor legal do documento.',
  decisaoResumoTitulo: 'O que esta decisão significa',
  glossarioIntro:
    'Os termos jurídicos que aparecem no texto oficial da sentença, explicados em linguagem comum.',
  continuacaoTextoOficial: 'Sentença arbitral · continuação',
  validadeTitulo: 'Validade e autenticidade',
  validadeEfeitos:
    'A sentença arbitral produz entre as partes os mesmos efeitos da sentença proferida pelos órgãos do Poder Judiciário, nos termos do Artigo 31 da Lei nº 9.307/1996.',
  rodapeGeracao: 'Documento gerado automaticamente pela Plataforma Arbitralis.',
} as const;

export const SELO_RESUMO_AUTOMATICO =
  'Resumo automático para facilitar a leitura. O texto oficial é a sentença na íntegra, abaixo.';
